<template>
  <div class="tracking-codes-settings brdr_content_wrpr">
    <h3 class="brdr_content_title">Custom codes
<!--    <span class="new-tag">-->
<!--	    New-->
<!--    </span>-->
    </h3>
    <loading v-show="loading"></loading>

    <div class="layout-row clickable-section" @click="popupOpen = true">
      <div class="flex">
        <p style="font-weight: 600;">Custom codes</p>
        <p>An easy way to add funnel-wide custom codes such as Snapchat Pixel, Google Tag or anything we do not have an app for yet.</p>
      </div>
      <div class="flex-none right-panel custom-codes" style="min-width: 200px">
	      <span v-if="!codes || codes.length===0" class="label">No custom codes!</span>
	      <span v-else class="label" v-html="brief" />
      </div>
    </div>

	  <popup-backdrop v-if="popupOpen" @close="popupOpen=false">
		  <tracking-codes-popup @close="popupOpen=false" :funnel-id="funnel.id" />
	  </popup-backdrop>
  </div>
</template>

<script>
import ConnectSmtpPopup from "@/components/popups/connect_smtp_popup";
import Loading from "@/components/Loading";
import API from "@/api"
import TrackingCodesPopup from "@/views/funnels/funnel-plus/funnel/tracking_codes/tracking_codes_popup";
import PopupBackdrop from "@/components/base/popup-backdrop";

export default {
    name: 'TrackingCodesSettings',
  props: ["funnel"],
  mixins: [API],
  components: {PopupBackdrop, TrackingCodesPopup, Loading, ConnectSmtpPopup},
  data: function (){
      return {
        loading: false,
	      codes: [],
        popupOpen: false,
      }
  },
  computed: {
			brief() {
				if (!this.codes.length) return 'no custom codes';
				let withName = this.codes.find(x=>!!x.name)
				let b = withName ? withName.name : 'Some nameless code'
				if (this.codes.length>1) {
					b += `<span class="plus-more">+ ${this.codes.length-1} more</span>`
				}
				return b;
			}
  },
  mounted() {
    this.load();
  },
  methods: {
	  async load() {
		  try {
			  this.loading = true;
			  this.codes = [];

			  this.codes = await this.api.codes.getAll(this.funnel.id);
			  this.$store.dispatch("setCodesStore", this.codes)
		  } catch (e) {
			  this.$error(e);
		  } finally {
			  this.loading = false;
		  }
	  },
  }
}
</script>

<style lang="scss">
.tracking-codes-settings {
	.brdr_content_title .new-tag {
		margin-left: 5px;
		font-size: 11px;
		background: lightgreen;
		color: darkgreen;
		padding: 3px 6px;
		border-radius: 5px;
	}

	.custom-codes {
		//font-size: 500;
		color: $darker-grey;
		.plus-more {
			margin-left: 5px;
			color: $grey;
			white-space: nowrap;
		}
	}
}
.clickable-section {
  border-top: 1px solid whitesmoke;
  border-bottom: 1px solid whitesmoke;
  padding: 0 10px;
  cursor: pointer;
  background: white;
  pointer-events: auto;
  transition: .2s all ease-in-out;

  &:hover {
    background: #f6f9fd;
    border-top: 1px solid #4268df;
    border-bottom: 1px solid #4268df;

    .label {
      color: #4268df;
    }
  }
  .right-panel {
    position: relative;
    display: flex;

    > .label {
      font-weight: bold;
      margin: auto;
	    display: inline-block;
	    text-align: right;
	    > img {
        margin-right: 10px;
        height: 20px;
        width: 20px;
      }
    }
  }
}
</style>
